import React from 'react';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';

function NotFound() {
  usePageTitle('404');
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      gap: '16px',
      color: 'var(--text)',
    }}>
      <h1 style={{ fontSize: '4rem', fontWeight: 700, margin: 0, color: 'var(--accent)' }}>404</h1>
      <p style={{ fontSize: '1.1rem', color: 'var(--text-muted)', margin: 0 }}>
        Page introuvable
      </p>
      <Link
        to="/"
        style={{
          marginTop: '8px',
          padding: '8px 20px',
          border: '1px solid var(--accent)',
          borderRadius: '6px',
          color: 'var(--accent)',
          textDecoration: 'none',
          fontSize: '0.9rem',
          transition: 'background 0.2s',
        }}
      >
        Retour à l'accueil
      </Link>
    </div>
  );
}

export default NotFound;
